import util from '@bmp-vue/core/api/util'
const controller = 'Autenticacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (login) {
    return util.Axios.Post(controller + '/AccessToken', login)
  },
  Logout: function () {
    return util.Axios.Delete(controller + '/AccessToken')
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshToken', dto)
  },
  RevokeRefreshToken: function (token) {
    return util.Axios.Delete(controller + 'RefreshToken', token)
  },
  SolicitarLinkSenha: function (dto) {
    return util.Axios.Post(controller + `/SolicitarLinkSenha/${dto}`, null)
  },
  RecuperarSenha: function (dto) {
    var request = { Password: dto.NovaSenha, ConfirmPassword: dto.NovaSenha, Code: dto.Token }
    return util.Axios.Post(controller + `/RecuperarSenha/${dto.Login}`, request)
  },
  ValidaTokenSenha: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  ValidaLogin: function () {
    return util.Axios.Post(controller + '/ValidaLogin', null)
  },
  FidoU2fOptions: function () {
    return util.Axios.Post(controller + '/FidoU2fOptions', null)
  },
  FidoU2fAuthorize: function (dto, usId) {
    var request = { AssertionResponse: dto, UsId: usId }
    return util.Axios.Post(controller + '/FidoU2fAuthorize', request)
  }
})
